import {
  IJobSearchFilterDTO,
  JobAssignmentStatusFilter,
  ISubmissionAnalyticsSearchFilterQuery,
  ITimezoneFilter,
} from 'wisestep-api';
import {
  getCurrentZoneAbbr,
  getCurrentZoneAbbrInHour,
  getCurrentZoneAbbrInMinute,
} from 'wisestep-base';

export interface ISeriesDataType {
  x: string;
  y: number;
}

export interface ISeriesDateType {
  x: string | Date;
  y: number;
}

export interface ISeriesBarType {
  name: string;
  data: ISeriesDateType[];
}

export interface IAggregation {
  key: string;
  doc_count: number;
  key_as_string?: string;
  aggregation?: {
    value?: number;
    buckets?: IAggregation[];
  };
  aggregation3?: {
    value?: number;
    buckets?: IAggregation[];
  };
  applyCount?: { value: number };
  viewCount?: { value: number };
  sum?: { value: number };
  value?: { value: number };
}

export interface BarChartDTO {
  key: string;
  doc_count: number;
  key_as_string?: string;
  totalHits?: number;
}

export interface IHeatMapDataType {
  name: string;
  data: ISeriesDataType[];
}

export interface rechartsPie {
  name: string;
  value: number;
}

export interface stackedColumnData {
  name: string;
  data: number[];
}

export interface IHits {
  total: number;
  max_score: number;
  hits: number[];
}

export const defaultHits: IHits = {
  total: 0,
  max_score: 0,
  hits: [],
};

export const analyticsDefaultQuery: ISubmissionAnalyticsSearchFilterQuery = {
  searchScope: 'EVERYTHING',
  relocationPreference: null,
  jobCandidateMapping: false,
  minSalary: 0,
  maxSalary: 0,
  salaryTimeSpan: null,
  radiusInMiles: '100',
  searchInCurrentLocation: true,
  searchInPreferredLocation: true,
  ignoreCandidatesWhereSalaryNotAvailable: false,
  candidateSearchType: 'All',
  searchAcross: ['BELONG_TO_TEAMS', 'OWN_TEAMS'],
  noticePeriodMinDays: 0,
  noticePeriodMaxDays: 0,
  includeUniqueCandidatesCount: true,
  recordsOnlyWithResume: false,
  page: 1,
  size: 0,
  jobSearchFields: ['currentJobTitle', 'mappedJobTitle', 'previousJobTitles'],
  auditQuery: false,
  candidateSearchTypeList: ['mapped', 'submitted', 'uploaded', 'applied'],
  datesUnionBy: 'CREATED_OR_UPDATED_BETWEEN',
  queryType: 'none',
  utcOffset: getCurrentZoneAbbr(),
  utcOffsetInHour: parseInt(getCurrentZoneAbbrInHour()),
  utcOffsetInMinute: parseInt(getCurrentZoneAbbrInMinute()),
  submittedByRecruiterIds: [],
};

export interface ISubmissionAnalyticsChartFilterProps {
  query: ISubmissionAnalyticsSearchFilterQuery;
}

export interface IMassMailingAnalyticsQueryProps {
  query: ITimezoneFilter;
}

export const jobAnalyticsDefaultQuery: IJobSearchFilterDTO = {
  jobAssignmentStatusFilter: JobAssignmentStatusFilter.Posted,
  jobStatus: 'All',
  postedOnJobBoards: '',
  searchAcross: ['MY_TEAMS', 'MY_PERSONAL_DATA'],
  datesUnionBy: 'CREATED_OR_UPDATED_BETWEEN',
  page: 0,
  size: 20,
  sort: ['createdOn,desc'],
};
